module.exports = __webpack_public_path__ + "static/media/maintenance-icon.7e114a43.svg";